const isProduction = process.env.REACT_APP_STAGE === "production"

const handleConfig = () => {
  if (isProduction) {
    return {
      apiKey: "AIzaSyCu73zf-XcbPtIan4BXxHJGAgwmUsbxJ7A",
      authDomain: "recoverylink-err-platform.firebaseapp.com",
      projectId: "recoverylink-err-platform",
      storageBucket: "recoverylink-err-platform.appspot.com",
      messagingSenderId: "560031736184",
      appId: "1:560031736184:web:0456b54567647fbde6288d",
    }
  }
  switch (process.env.REACT_APP_STAGE) {
    case "qaproduction":
      return {
        apiKey: "AIzaSyAeb0xcWvUGv3nVTdOd0jvfcVCDUZTBkio",
        authDomain: "recoverylink-qa-platform.firebaseapp.com",
        projectId: "recoverylink-qa-platform",
        storageBucket: "recoverylink-qa-platform.appspot.com",
        messagingSenderId: "1091427460345",
        appId: "1:1091427460345:web:5b90024d393107f9ef6e28",
        measurementId: "G-B6VR3J3Q3J",
      }
    case "staging":
      return {
        apiKey: "AIzaSyAJKVKXaR-thyN4sWY-ZZ0OCVYYn_gyt0w",
        authDomain: "recoverylink-err-stage.firebaseapp.com",
        projectId: "recoverylink-err-stage",
        storageBucket: "recoverylink-err-stage.appspot.com",
        messagingSenderId: "323043065409",
        appId: "1:323043065409:web:011d50e5a6ed65ccc590c0",
      }
    default:
      return {
        apiKey: "AIzaSyDUyUyZ5h4N8uyFGRGtrqwCMDWS7p6YBhY",
        authDomain: "recoverylink-err-dev.firebaseapp.com",
        projectId: "recoverylink-err-dev",
        storageBucket: "recoverylink-err-dev.appspot.com",
        messagingSenderId: "435913833905",
        appId: "1:435913833905:web:cb5c7021f53dce6eb35190",
        measurementId: "G-CXB3LG94H0",
      }
  }
}

const config = handleConfig()

export default config

